import  HomologousProcedureTableContainer from './HomologousProcedureTableContainer';

export default  HomologousProcedureTableContainer;